import { FC, ReactNode } from "react";
import { StyleSheet, View } from "@react-pdf/renderer";

import { Avatar, AvatarVariant, Card, Field } from "../../common";

type Variant = AvatarVariant;

type Props = {
  label: string;
  value: string;
  variant?: Variant;
  children?: ReactNode;
};

const styles = StyleSheet.create({
  wrapper: {
    // former "sideHeader"
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: 16,
    width: "100%",
  },
  labelWrapper: {
    // former "avatarName"
    maxWidth: "80%",
  },
});

export const CardAvatarLayout: FC<Props> & {
  variant: typeof Avatar.variant;
} = ({ label, value, children, variant }) => {
  return (
    <Card>
      <View style={styles.wrapper}>
        <View style={styles.labelWrapper}>
          <Field label={label} value={value} />
        </View>

        <Avatar title={value} variant={variant} />
      </View>

      {children}
    </Card>
  );
};

CardAvatarLayout.variant = Avatar.variant;
